import React from "react";

const DashboardPage: React.FC = () => {
  return (
    <div className="container mx-auto">
      <h1 className="text-3xl font-bold">{"dashboard"}</h1>
    </div>
  );
};

export default DashboardPage;
